<template>
  <b-container>
    <div class="view-transaction-page page">
      <review-form ref="review" :transaction="transaction"></review-form>

      <div
        class="view-transaction__content page__card page__card--full page__card--no-bg mt-0"
      >
        <div class="view-transaction__left">
          <transaction-details :transaction="transaction" />
        </div>
        <div class="view-transaction__right">
          <div ref="sticky" class="view-transaction__right__border">
            <b-card class="price-breakdown">
              <div class="card-title d-flex">
                <div
                  class="job-img"
                  :style="{
                    backgroundImage: 'url(' + toolImage + ')',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                  }"
                ></div>
                <div
                  class="d-flex flex-column justify-content-center align-self-start"
                >
                  <h2 class="job-name">{{ tool.name }}</h2>
                  <div class="job-rate d-flex flex-row">
                    <rate
                      :value="reviewRating"
                      :has-label="false"
                      :disabled="true"
                    ></rate>
                    <p>
                      ({{ reviewTotal }} review{{ reviewTotal > 1 ? 's' : '' }})
                    </p>
                  </div>
                </div>
              </div>
              <div class="price-breakdown__content">
                <b-row>
                  <b-col md="4">Dates</b-col>
                  <b-col
                    class="d-flex flex-row justify-content-end align-items-center"
                    >{{ from }}
                    <b-img
                      width="24"
                      class="pay-arrow"
                      :src="require('@/assets/icons/arrow-right-tail.svg')"
                    ></b-img>
                    {{ to }}</b-col
                  >
                </b-row>
                <b-row>
                  <b-col
                    >${{ tool.price | price }} x
                    {{ tool.number_of_days }} day(s)</b-col
                  >
                  <b-col class="text-right"
                    >${{ tool.total.sub_total | price }}</b-col
                  >
                </b-row>
                <b-row>
                  <b-col>GST ({{ tool.tax }}%)</b-col>
                  <b-col class="text-right"
                    >${{ tool.total.tax | price }}</b-col
                  >
                </b-row>
                <b-row v-if="isOwner">
                  <b-col class="d-flex flex-row align-items-end"
                    >Service fee
                    <b-img
                      id="info-popover"
                      width="24"
                      height="24"
                      class="pay-info"
                      :src="require('@/assets/images/info.svg')"
                    ></b-img>
                    <b-popover
                      target="info-popover"
                      triggers="hover"
                      placement="top"
                    >
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam...
                    </b-popover>
                  </b-col>
                  <b-col class="text-right"
                    >(${{ tool.total.service_fee | price }})</b-col
                  >
                </b-row>
                <b-row class="pay-total">
                  <b-col><h3>Total</h3></b-col>
                  <b-col class="text-right"
                    ><h3>${{ tool.total.grand_total | price }}</h3></b-col
                  >
                </b-row>
              </div>

              <div
                v-if="transaction"
                class="transaction-menus d-flex flex-column"
              >
                <b-button
                  variant="outline-primary"
                  :disabled="!canReview"
                  @click="$refs.review.show()"
                  >Leave a review</b-button
                >
                <b-button
                  variant="primary"
                  :disabled="!canRentAgain"
                  :to="toRentAgain"
                  >Rent Again</b-button
                >
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * View transactions page
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import Sticky from '@/utils/mixins/sticky'
import Rate from '@/components/inputs/Rate'
import ReviewForm from '@/components/forms/ReviewForm'
import TransactionDetails from '@/components/cards/TransactionDetails'

export default {
  metaInfo: function() {
    return this.transaction
      ? {
          title: `View Transaction - ${this.transaction.renter_code}`
        }
      : {
          title: 'View Transaction'
        }
  },
  components: {
    Rate,
    ReviewForm,
    TransactionDetails
  },
  mixins: [Sticky],
  computed: {
    ...mapState({
      transaction: state => state.transaction.transactionDetails
    }),

    from() {
      if (!this.transaction || !this.transaction.from) return 'NA'
      return dayjs(this.transaction.from).format('DD/M/YYYY')
    },

    to() {
      if (!this.transaction || !this.transaction.to) return 'NA'
      return dayjs(this.transaction.to).format('DD/M/YYYY')
    },

    tool() {
      if (!this.transaction) return { total: {} }
      return this.transaction.details
    },

    toolImage() {
      if (
        !this.transaction ||
        !this.transaction.tool ||
        !this.transaction.tool.image
      )
        return require('@/assets/images/img-placeholder.svg')
      return (
        this.transaction.tool.image.thumb_url ||
        this.transaction.tool.image.permanent_url
      )
    },

    review() {
      if (!this.transaction) return
      return this.transaction.reviews
    },

    reviewTotal() {
      return this.review ? this.review.total : 0
    },

    reviewRating() {
      return this.review ? this.review.average : 0
    },

    isOwner() {
      return this.transaction ? this.transaction.is_tool_owner : false
    },

    canReview() {
      return this.transaction
        ? !this.isOwner && this.transaction.accepted
        : false
    },

    canRentAgain() {
      return this.transaction
        ? !this.isOwner &&
            (this.transaction.accepted ||
              this.transaction.declined ||
              this.transaction.expired)
        : false
    },

    toRentAgain() {
      return this.transaction
        ? {
            name: 'job.view-job-page',
            params: {
              id: this.transaction.tool.permalink,
              title: this.transaction.details.name
                .replace(/ +/g, '-')
                .toLowerCase()
            }
          }
        : {}
    }
  },
  data: function() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      getTransactionDetails: 'transaction/getTransactionDetails'
    }),
    ...mapMutations({
      clearTransactionDetails: 'transaction/clearTransactionDetails'
    }),
    async fetchTransaction() {
      if (this.loading) return
      this.loading = true
      await this.getTransactionDetails(this.$route.params.id)
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$router.replace({ name: 'page-not-found' })
        })
    }
  },
  async created() {
    await this.clearTransactionDetails()
    await this.fetchTransaction()
  }
}
</script>
<style scoped lang="scss">
.view-transaction-page {
  margin-top: 50px;

  .page__header {
    padding: 0px 0 35px 0;
  }

  .view-transaction__content {
    display: flex;
    flex-direction: row;

    .view-transaction__left {
      width: 53.5%;
      margin-right: 4%;
    }

    .view-transaction__right {
      flex-grow: 1;
      padding-top: 30px;

      &__border {
        > * {
          margin-bottom: 17.5px;
        }
      }

      .price-breakdown {
        max-width: 600px;

        .card-title {
          padding-bottom: 25px;
          margin-bottom: 45px;
          border-bottom: 1px solid #e3e3e3;
        }

        .card-body {
          padding: 1.8rem 2.65rem;
        }

        .job-name {
          font-size: 1.7rem;
          line-height: 1.7rem;
        }

        .job-img {
          width: 92.5px;
          height: 90px;
          margin-right: 20px;
          border-radius: 5px;
          border: 1px solid #efefef;
        }

        .job-rate {
          > p {
            font-size: 0.9rem;
            line-height: 1.1rem;
            color: #6c6c6c;
          }

          .rate {
            margin-right: 5px;
          }
        }

        &__content {
          font-size: 0.9rem;

          .row {
            margin-bottom: 25px;
          }

          .pay-arrow {
            margin: 0 10px 0 25px;
          }

          .pay-info {
            margin-left: 17.5px;
            cursor: pointer;
          }

          .pay-total {
            font-weight: 900;
            margin-top: 40px;
            margin-bottom: 10px;
            color: #444a51;
          }
        }
      }

      .transaction-menus {
        margin-top: 32.5px;

        .btn {
          margin-bottom: 20px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .view-transaction-page {
    .view-transaction__content {
      flex-direction: column;

      .view-transaction__left,
      .view-transaction__right {
        width: 100%;
        margin-right: 0;
      }

      .view-transaction__right {
        .price-breakdown {
          max-width: inherit;
        }
      }
    }
  }
}
</style>
